import update from 'immutability-helper';
import { A } from '../actions/supplies';

const initialState = {
  getSupplies: {
    isFetching: false,
    error: null,
  },
  supplies: [],
  suppliesCount: 0, //Общее число заказов без учета пагинации

  getCurrentSupply: {
    isFetching: false,
    error: null,
  },
  getSupplyHistory: {
    isFetching: false,
    error: null,
  },
  getSuppliesReport: {
    isFetching: false,
    error: null,
  },
  getSuppliesExportTasks: {
    isFetching: false,
    error: null,
  },
  getAcceptance: {
    isFetching: false,
    error: null,
  },

  currentSupply: null,
  currentSupplyUnsaved: false,
  currentAcceptance: null,
  worksheetSupplyFormTemplate: null,

  copySupply: {
    isFetching: false,
    error: null,
  },

  refreshSupply: {
    isFetching: false,
    error: null,
  },

  getSupplyWorksheet: {
    isFetching: false,
    error: null,
  },

  updateSupplyWorksheet: {
    isFetching: false,
    error: null,
  },

  getSupplyWorksheetFormTemplate: {
    isFetching: false,
    error: null,
  },

  changeOrderFbmDocsNecessary: {
    isFetching: false,
    error: null,
  },
};

const supplies = (state = initialState, action) => {
  switch (action.type) {
    case A.FETCH_SUPPLIES_REQUEST:
      return update(state, {
        getSupplies: {
          isFetching: { $set: true },
          error: { $set: null },
        },
        supplies: { $set: [] },
        suppliesCount: { $set: 0 },
      });

    case A.FETCH_SUPPLIES_SUCCESS:
      return update(state, {
        getSupplies: {
          isFetching: { $set: false },
          error: { $set: null },
        },
        supplies: { $set: action.purchaseOrders },
        suppliesCount: { $set: action.recordsTotal },
      });

    case A.FETCH_SUPPLIES_FAILURE:
      return update(state, {
        getSupplies: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.FETCH_CURRENT_SUPPLY_REQUEST:
      return update(state, {
        getCurrentSupply: {
          isFetching: { $set: true },
          error: { $set: null },
        },
        currentSupplie: { $set: null },
      });

    case A.FETCH_CURRENT_SUPPLY_SUCCESS:
      return update(state, {
        getCurrentSupply: {
          isFetching: { $set: false },
          error: { $set: null },
        },
        currentSupply: { $set: action.supply },
      });

    case A.FETCH_CURRENT_SUPPLY_FAILURE:
      return update(state, {
        getCurrentSupply: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.SET_CURRENT_SUPPLY_UNSAVED:
      return update(state, {
        currentSupplyUnsaved: { $set: action.currentSupplyUnsaved },
      });

    case A.SET_CURRENT_SUPPLY:
      return update(state, {
        currentSupply: { $set: action.supply },
      });

    case A.REQUEST_GET_SUPPLY_HISTORY:
      return update(state, {
        getSupplyHistory: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_SUPPLY_HISTORY:
      return update(state, {
        getSupplyHistory: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_SUPPLY_HISTORY:
      return update(state, {
        getSupplyHistory: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_SUPPLIES_REPORT:
      return update(state, {
        getSuppliesReport: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.REQUEST_GET_SUPPLIES_EXPORT_TASKS:
      return update(state, {
        getSuppliesExportTasks: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.REQUEST_COPY_SUPPLY:
      return update(state, {
        copySupply: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_COPY_SUPPLY:
      return update(state, {
        copySupply: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_COPY_SUPPLY:
      return update(state, {
        copySupply: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_REFRESH_SUPPLY:
      return update(state, {
        refreshSupply: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_REFRESH_SUPPLY:
      return update(state, {
        refreshSupply: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_REFRESH_SUPPLY:
      return update(state, {
        refreshSupply: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ACCEPTANCE:
      return update(state, {
        getAcceptance: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ACCEPTANCE:
      return update(state, {
        getAcceptance: {
          isFetching: { $set: false },
        },
        currentAcceptance: { $set: action.acceptance }, //TODO: Проверить после подготовки бэка
      });

    case A.ERROR_GET_ACCEPTANCE:
      return update(state, {
        getAcceptance: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_SUPPLY_WORKSHEET:
      return update(state, {
        getSupplyWorksheet: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_SUPPLY_WORKSHEET:
      return update(state, {
        getSupplyWorksheet: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_SUPPLY_WORKSHEET:
      return update(state, {
        getSupplyWorksheet: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_SUPPLY_WORKSHEET:
      return update(state, {
        updateSupplyWorksheet: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_SUPPLY_WORKSHEET:
      return update(state, {
        updateSupplyWorksheet: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_SUPPLY_WORKSHEET:
      return update(state, {
        updateSupplyWorksheet: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE:
      return update(state, {
        getSupplyWorksheetFormTemplate: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE:
      return update(state, {
        getSupplyWorksheetFormTemplate: {
          isFetching: { $set: false },
        },
        worksheetSupplyFormTemplate: { $set: action.data },
      });

    case A.ERROR_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE:
      return update(state, {
        getSupplyWorksheetFormTemplate: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_POST_ORDER_FBM_DOCS_NECESSARY:
      return update(state, {
        changeOrderFbmDocsNecessary: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_POST_ORDER_FBM_DOCS_NECESSARY:
      return update(state, {
        changeOrderFbmDocsNecessary: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_POST_ORDER_FBM_DOCS_NECESSARY:
      return update(state, {
        changeOrderFbmDocsNecessary: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default supplies;
